import { VERTICAL_FILTER_STORAGE_ID } from 'components/Common/VerticalFilterV2/constants';
import {
  JWT,
  DEMO_STUDENT_JWT,
  REFRESH_TOKEN,
  DEMO_STUDENT_REFRESH_TOKEN,
} from 'constants/system';
import { LOCAL } from 'services/constants';

import { eraseCookie } from 'utils/cookies';

const ExpiredDate = '1970-01-01';

const removeJwt = (isLogout = true) => {
  // Remove both student demo and counselor account JWT
  const isSchooLinksDomain = window?.location?.href
    ? window?.location?.href.indexOf('schoolinks.com/') !== -1
    : false;

  const prodExpiredCookieConfig = {
    domain: '.schoolinks.com',
    path: '/',
    expires: new Date(ExpiredDate),
  };

  const allExpiredCookieConfig = {
    path: '/',
    expires: new Date(ExpiredDate),
  };

  // Remove both student demo and counselor account JWT
  const cookieConfig =
    ENVIRONMENT === LOCAL || !isSchooLinksDomain
      ? allExpiredCookieConfig
      : prodExpiredCookieConfig;

  // Keeping those out because they can be removed without removing the normal JWTs
  localStorage.removeItem(DEMO_STUDENT_JWT);
  localStorage.removeItem(DEMO_STUDENT_REFRESH_TOKEN);

  if (isLogout) {
    eraseCookie({
      name: JWT,
      options: cookieConfig,
    });
    eraseCookie({
      name: REFRESH_TOKEN,
      options: cookieConfig,
    });
    localStorage.removeItem('selectedStudentScopeFilter');
    localStorage.removeItem(VERTICAL_FILTER_STORAGE_ID);
  }
};

export default removeJwt;
